// src/components/LanguageSwitcher.js
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SUPPORTED_LANGS } from "../config/i18n";
import { buildLangPath } from "../utils/i18nRouting";

export function LanguageSwitcher() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams(); // current lang from URL

  const handleChangeLang = (targetLang) => {
    const newPath = buildLangPath(location.pathname, targetLang);
    navigate(newPath, { replace: false });
  };

  return (
    <div className="lang-switcher">
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => handleChangeLang(code)}
          disabled={code === lang}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
